<template>
  <div
    class="d-flex align-center justify-center"
    :style="{ minHeight: `${minHeight}px` }"
  >
    <VProgressCircular indeterminate color="primary" size="48" />
  </div>
</template>

<script setup lang="ts">
/**
 * Placeholder for dialog content that is fetched on first open, such as the
 * login flow (VIP-12356). The min-height keeps the sheet from collapsing to a
 * bare header row while the chunk arrives; the default is roughly the height
 * of the login form, so the dialog does not jump when the content lands.
 */
withDefaults(defineProps<{ minHeight?: number }>(), { minHeight: 320 })
</script>
